import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, Pressable, Text, VStack } from "native-base";
import { useCallback, useEffect, useState } from "react";
import { useFormContext } from "@madmedical/form";
import { PREGNANCY_SYMPTOMS_FOR_HUMANS, PregnancySymptom, PregnancyWellBeingStatus, WELL_BEING_STATUS_FOR_HUMANS, } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../../form/SubmitButton";
import Button from "../../atoms/Button";
import ModalContent from "../../molecules/ModalContent";
import DateTimeInput from "../../form/DateTimeInput";
import FormTextAreaControl from "../../form/FormTextAreaControl";
import PregnantMoodPics from "../../molecules/Pregnancy/PregnantMoodPics";
import useResponsive from "../../util/useResponsive";
import MultiSelect from "../../form/MultiSelect";
const moodTypesList = Object.values(PregnancyWellBeingStatus);
const tunetekLista = Object.values(PregnancySymptom).map((value) => ({
    key: value,
    text: PREGNANCY_SYMPTOMS_FOR_HUMANS[value],
}));
const PregnancyMoodModal = ({ onClose, onSubmitPress, isSuccess, isEdit = false, }) => {
    const [selectedStatus, setSelectedStatus] = useState();
    const [isValid, setIsValid] = useState(false);
    const { isSmallScreen } = useResponsive();
    const { getValues, setValue, watch } = useFormContext();
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const selectStatus = useCallback((status) => {
        setSelectedStatus(status);
        setValue("status", status);
    }, [setValue]);
    const chosenSmytoms = watch("symptoms");
    const userSelectedStatus = watch("status");
    useEffect(() => {
        if (isEdit) {
            //TODO check useEffect
            const { comment, symptoms, status, createdAt } = getValues();
            setValue("createdAt", createdAt);
            setValue("comment", comment);
            setValue("symptoms", symptoms);
            setValue("status", status);
            selectStatus(status);
        }
    }, [isEdit, setValue, getValues, selectStatus]);
    useEffect(() => {
        setIsValid(false);
        if ((chosenSmytoms === null || chosenSmytoms === void 0 ? void 0 : chosenSmytoms.length) > 0 && userSelectedStatus) {
            setIsValid(true);
        }
    }, [chosenSmytoms, userSelectedStatus]);
    const formatMood = useCallback((status) => {
        switch (status) {
            case PregnancyWellBeingStatus.BadTemper:
                return WELL_BEING_STATUS_FOR_HUMANS[PregnancyWellBeingStatus.BadTemper];
            case PregnancyWellBeingStatus.Moody:
                return WELL_BEING_STATUS_FOR_HUMANS[PregnancyWellBeingStatus.Moody];
            case PregnancyWellBeingStatus.Fluctuating:
                return WELL_BEING_STATUS_FOR_HUMANS[PregnancyWellBeingStatus.Fluctuating];
            case PregnancyWellBeingStatus.Calm:
                return WELL_BEING_STATUS_FOR_HUMANS[PregnancyWellBeingStatus.Calm];
            case PregnancyWellBeingStatus.Cheerful:
                return WELL_BEING_STATUS_FOR_HUMANS[PregnancyWellBeingStatus.Cheerful];
            default:
                return "";
        }
    }, []);
    const onSubmit = () => {
        onSubmitPress();
    };
    const { t } = useTranslation();
    return (_jsxs(ModalContent, Object.assign({ header: `${isEdit ? t("editTextInput") : t("newTextInput")}`, footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onPress: onClose, variant: "outlined" }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmit, label: t("save"), isDisabled: !isValid })] }) }, { children: [_jsx(DateTimeInput, { name: "createdAt", isRequired: true, label: t("appointment") }), _jsxs(VStack, Object.assign({ space: 4, pb: 6, mt: 4 }, { children: [_jsxs(Box, { children: [_jsx(Text, Object.assign({ color: "gray.600", fontWeight: "medium", mb: 1 }, { children: t("generalFeeling") })), _jsx(HStack, Object.assign({ direction: "row", width: "100%", flexWrap: "wrap" }, { children: moodTypesList.map((mood) => (_jsx(Pressable, Object.assign({ onPress: () => selectStatus(mood), mr: 2, mb: 2 }, { children: _jsxs(Box, Object.assign({ borderColor: selectedStatus === mood
                                            ? "green.500"
                                            : "gray.100", borderWidth: selectedStatus === mood ? 2 : 1, p: 2, borderRadius: 5, alignItems: "center", justifyContent: "center", w: isSmallScreen ? 60 : 100, h: isSmallScreen ? 60 : 100 }, { children: [_jsx(PregnantMoodPics, { status: mood }), !isSmallScreen && (_jsx(Text, Object.assign({ mt: 2, mb: -1, textAlign: "center", fontSize: "xs" }, { children: formatMood(mood) })))] })) }), mood))) }))] }), _jsx(Box, { children: _jsx(MultiSelect, { label: t("realizedSymptoms"), name: "symptoms", list: tunetekLista, size: "md", width: "100%", maxItems: 5, hint: "Maximum 5 db." }) }), _jsx(FormTextAreaControl, { label: t("comment"), name: "comment", labelProps: {
                            _text: { color: "gray.600" },
                        }, maxLength: 100, textareaHeight: isSmallScreen ? 160 : 100, placeholder: t("addComment") + "..." })] }))] })));
};
export default PregnancyMoodModal;
